import React from 'react';

const LastUpdateIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M22.75 14C22.75 9.1675 18.8324 5.25 14 5.25C11.7027 5.25 9.61225 6.1353 8.05108 7.58333H9.625C10.1082 7.58333 10.5 7.97509 10.5 8.45833C10.5 8.94158 10.1082 9.33333 9.625 9.33333H6.125C5.64175 9.33333 5.25 8.94158 5.25 8.45833V4.95833C5.25 4.47509 5.64175 4.08333 6.125 4.08333C6.60824 4.08333 7 4.47509 7 4.95833V6.17363C8.85765 4.51099 11.3108 3.5 14 3.5C19.799 3.5 24.5 8.20101 24.5 14C24.5 19.799 19.799 24.5 14 24.5C8.20101 24.5 3.5 19.799 3.5 14C3.5 13.4536 3.54172 12.9171 3.62216 12.3933C3.68783 11.9656 4.06727 11.6667 4.49993 11.6667C5.03544 11.6667 5.42319 12.1779 5.34477 12.7077C5.28234 13.1294 5.25 13.5609 5.25 14C5.25 18.8324 9.1675 22.75 14 22.75C18.8324 22.75 22.75 18.8324 22.75 14ZM14.5833 9.04167C14.5833 8.55842 14.1916 8.16667 13.7083 8.16667C13.2251 8.16667 12.8333 8.55842 12.8333 9.04167V14.2917C12.8333 14.7749 13.2251 15.1667 13.7083 15.1667H16.625C17.1082 15.1667 17.5 14.7749 17.5 14.2917C17.5 13.8084 17.1082 13.4167 16.625 13.4167H14.5833V9.04167Z"
      fill="#27B0E0"
    />
  </svg>
);

export default LastUpdateIcon;
